export default "<div class=\"dashboard-container\">\n    <router-outlet></router-outlet>\n</div>\n\n"